export default __webpack_public_path__ + "static/media/umit-karabudak.f78f11ad.png";